<template>
  <v-card>
    <v-card-title
      class="info white--text"
    >
      <v-layout
        justify-space-between
        align-center
      >
        <div class="subheading font-weight-medium">
          Recent Posts
        </div>
        <v-btn
          icon
          :to="{ name: 'blog.posts' }"
        >
          <v-icon
            color="white"
          >
            open_in_new
          </v-icon>
        </v-btn>
      </v-layout>
    </v-card-title>
    <v-divider />
    <v-data-table
      :items="items"
      :headers="headers"
      disable-initial-sort
      hide-actions
    >
      <template v-slot:items="props">
        <td v-text="props.item.title" />
        <td v-text="props.item.category" />
        <td v-text="fromNow(props.item.created_at)" />
        <td v-text="props.item.published_at ? fromNow(props.item.published_at) : 'N/A'" />
        <td v-text="props.item.created_by" />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { fromThisDate } from '@/helpers/utilities'
export default {
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    headers: [
      {
        text: 'Title',
        value: 'title'
      },
      {
        text: 'Category',
        value: 'category'
      },
      {
        text: 'Created At',
        value: 'created_at'
      },
      {
        text: 'Published At',
        value: 'published_at'
      },
      {
        text: 'Created By',
        value: 'created_by'
      },
    ]
  }),
  methods: {
    fromNow (value) {
      return fromThisDate(value)
    }
  }
}
</script>
